import { render } from "./modelone.vue?vue&type=template&id=f8bc23e4&scoped=true"
import script from "./modelone.vue?vue&type=script&lang=js"
export * from "./modelone.vue?vue&type=script&lang=js"

import "./modelone.vue?vue&type=style&index=0&id=f8bc23e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bc23e4"]])

export default __exports__